/** Pickers, plain server errors, schema forms and related screen texts (ADR-0065). */
const queueEn = {
  "case-worker": "Case workers",
  "case-supervisor": "Case supervisors",
  approver: "Approvers",
  requester: "The person who asked",
  "finance-approver": "Finance approvers",
  "finance-director": "Finance directors",
  cfo: "Chief financial officer",
  "named-approvers": "Named approvers",
  reviewer: "Reviewers",
  finance: "Finance team",
  "channel-agent": "Contact centre agents",
  "channel-supervisor": "Contact centre supervisors",
  "privacy-officer": "Privacy officers",
  "release-approver": "Release approvers",
};
const queueAr = {
  "case-worker": "موظفو الحالات",
  "case-supervisor": "مشرفو الحالات",
  approver: "المعتمدون",
  requester: "الشخص الذي طلب",
  "finance-approver": "المعتمدون الماليون",
  "finance-director": "المديرون الماليون",
  cfo: "المدير المالي التنفيذي",
  "named-approvers": "معتمِدون بالاسم",
  reviewer: "المراجعون",
  finance: "الفريق المالي",
  "channel-agent": "موظفو مركز الاتصال",
  "channel-supervisor": "مشرفو مركز الاتصال",
  "privacy-officer": "مسؤولو الخصوصية",
  "release-approver": "معتمدو الإصدارات",
};

export default {
  en: {
    loading: "Loading…",
    person: {
      placeholder: "Search by name or e-mail",
      failed: "People could not be loaded. Try again in a moment.",
      none: "No one found. Check the spelling or try the e-mail address.",
      noneInQueue: "No one in this queue matches.",
      fromQueue: "Only people who work this queue are offered.",
    },
    queue: { ...queueEn, placeholder: "Choose a queue", help: "The team that works new cases of this kind." },
    caseType: {
      placeholder: "Choose the kind of case",
      other: "Other ({{key}})",
      help: "The kind of case decides who works it, how fast to respond and what information is needed.",
    },
    agent: { placeholder: "Choose an agent", failed: "Agents could not be loaded.", none: "No agents yet." },
    case: { placeholder: "Search cases by title or reference", failed: "Cases could not be loaded.", none: "No case found.", selected: "Selected case" },
    timezone: { placeholder: "Search a city or time zone" },
    schemaForm: {
      empty: "(empty)",
      yes: "Yes",
      no: "No",
      rawLabel: "All values as code (JSON)",
      rawInvalid: "This is not valid JSON yet. Your change is applied once it is valid.",
      rawToggle: "Show as code (for experts)",
      rawHelp: "Edit the values as JSON instead of the form.",
      noSchema: "This action does not describe its fields, so its values are shown as code.",
      extra: "Not described by the action; sent as is.",
      noChanges: "No changes.",
      becomes: "becomes",
      issue: {
        required: "Required.",
        type: "Enter a value of the right kind ({{type}}).",
        enum: "Choose one of the offered values.",
        min: "Must be at least {{n}}.",
        max: "Must be at most {{n}}.",
        minLength: "Must have at least {{n}} characters.",
        maxLength: "Must have at most {{n}} characters.",
        pattern: "The format is not accepted.",
        notAllowed: "This action does not accept this field.",
      },
    },
    error: {
      raw: "The system said: {{raw}}",
      kind: {
        offline: { title: "The platform cannot be reached", next: "Check your connection and try again. If it keeps happening, tell your administrator." },
        signed_out: { title: "Your session has ended", next: "Sign in again and repeat the action." },
        forbidden: { title: "You are not allowed to do this", next: "Ask your administrator if you need this access." },
        not_found: { title: "This item no longer exists", next: "Reload the page; someone may have removed or moved it." },
        conflict: { title: "Someone changed this at the same time", next: "Reload to see the latest version, then try again." },
        invalid: { title: "Some information needs fixing", next: "Correct the marked information and try again." },
        too_large: { title: "The file is too large", next: "Choose a smaller file or split it." },
        unsupported: { title: "This kind of file is not supported", next: "Use a PDF, an image or an office document." },
        rate_limited: { title: "Too many requests right now", next: "Wait a minute and try again." },
        unavailable: { title: "A part of the platform is not available right now", next: "Nothing was changed. Try again in a few minutes." },
        server: { title: "Something went wrong on the platform", next: "Nothing was changed. Try again; if it keeps happening, tell your administrator." },
        unknown: { title: "The action did not complete", next: "Try again. If it keeps happening, tell your administrator." },
      },
      detail: {
        not_found_thing: "It could not be found ({{thing}}).",
        changed_meanwhile: "Someone else changed it while you were working. Reload to see their change.",
        claimed_by_other: "Another reviewer is already working on this task.",
        task_state: "This task is already {{status}}, so it cannot be changed now.",
        status_transition: "A case cannot move from {{from}} to {{to}}.",
        user_exists: "A person with this username or e-mail already exists.",
        already_deployed: "This version is already in use there.",
        promote_first: "Move it to {{env}} first.",
        case_type_in_use: "Cases of this kind exist, so it cannot be deleted. Switch it off instead.",
        needs_role: "Your account does not have access to this. If you need it, ask your administrator.",
        not_participant: "You do not work on this case.",
        not_in_queue: "You are not a member of the queue this task belongs to.",
        assignee_or_supervisor: "Only the person it is assigned to or a case supervisor can do this.",
        reopen_supervisor: "Only a case supervisor can reopen a closed case.",
        clearance: "Your clearance is lower than the classification of this case.",
        human_only: "This must be done by a person signed in directly, not through an agent.",
        other_tenant: "This belongs to another organisation.",
        missing_field: "Missing information: {{field}}.",
        must_be_number: "{{field}} must be a number.",
        must_be_date: "{{field}} must be a date.",
        case_type_off: "This kind of case is switched off. Choose another one.",
        unknown_timezone: "{{zone}} is not a known time zone.",
        hours_order: "The working day must start before it ends.",
        no_working_days: "Choose at least one working day.",
        edits_required: "Change at least one value, or choose Approve.",
        signature_required: "The approval could not be signed. Try again.",
        input_no_reject: "A request for information cannot be rejected. Reassign it or escalate it.",
        assignee_or_queue: "Choose a person or a queue.",
        one_file: "Choose one file.",
        invalid_generic: "This value is not accepted.",
        roles_not_assignable: "These roles cannot be given: {{roles}}.",
        email_invalid: "This e-mail address is not valid.",
        username_invalid: "Usernames use lower-case letters, digits, dots, dashes or underscores (3–63 characters).",
        idp_rejected: "The sign-in system refused the change (for example a weak password).",
        field_required: "This is required.",
        too_long: "This is too long (at most {{n}} characters).",
        too_short: "This is too short (at least {{n}} characters).",
        wrong_format: "The format is not accepted.",
        must_be_number_generic: "Enter a number.",
        too_small: "This must be at least {{n}}.",
        too_big: "This must be at most {{n}}.",
        value_error: "{{text}}",
        audit_down: "The audit log is not reachable, so nothing was changed. Try again in a few minutes.",
        idp_down: "The sign-in system is not reachable. Try again in a few minutes.",
        service_down: "A platform service is not reachable. Try again in a few minutes.",
      },
    },
    edit: {
      title: "Change the values",
      help: "Correct what the agent proposed. The change is signed with your decision and the agent continues with your values.",
      valid: "All values are valid.",
      fix: "Fix the marked fields first ({{count}}).",
      changes: "What you changed",
      diffChanged: "The values that will be used, with your changes marked.",
      diffSame: "The values the agent proposed.",
    },
    reassign: { pick: "Choose a person in this queue", done: "Task reassigned" },
    tech: {
      toolAction: "Tool action",
      argsJson: "Values as code",
      step: "Step",
      documentUri: "Document address",
      mediaType: "File type",
      outcomeCode: "Outcome code",
    },
    chat: {
      canDo: "What it can do:",
      aboutAgent: "About {{name}}",
      tryAsking: "Try asking",
    },
    documents: {
      unnamed: "Document",
      kind: { pdf: "PDF document", png: "Image", jpeg: "Image", tiff: "Scanned image", plain: "Text file", other: "Document" },
      added: "Added {{when}}",
      read: "Read by document intelligence",
      readFailed: "The document could not be read.",
      attached: "{{name}} attached: {{kind}}, {{pages}} page(s).",
      attachedPending: "{{name}} attached. It is still being read; details appear later.",
      failed: "{{name}} was not attached.",
      classification: "Sensitivity",
      reading: "Reading {{name}}…",
      upload: "Upload a document",
      help: "The document is read (type, pages, personal data) and attached to this case.",
    },
    identifier: {
      title: "Identifiers",
      none: "No identifiers yet.",
      type: "Identifier type",
      value: "Number or value",
      add: "Add an identifier",
      remove: "Remove {{type}}",
      types: {
        national_id: "National ID / Iqama",
        cr_number: "Commercial registration (CR) number",
        iban: "IBAN",
        passport: "Passport number",
        email: "E-mail",
        phone: "Phone",
        employee_no: "Employee number",
        vendor_no: "Supplier number",
      },
      hint: {
        generic: "Check this value.",
        national_id: "Usually 10 digits starting with 1 (citizen) or 2 (resident).",
        cr_number: "Usually 10 digits.",
        iban: "For example SA03 8000 0000 6080 1016 7519.",
        passport: "Letters and digits only.",
        email: "For example name@example.com.",
        phone: "Digits only, for example +966 5X XXX XXXX.",
      },
    },
    tenant: {
      regionHelp: "Where the organisation's data is kept. Options come from the registered models.",
      regionsHelp: "Model answers may only be produced in these regions. Leave empty to allow any approved region.",
      anyRegion: "Any approved region",
      providersHelp: "Which model providers this organisation may use. Leave empty to allow every approved provider.",
      anyProvider: "Every approved provider",
      timezoneLink: "Change in the business calendar",
      timezoneHelp: "The organisation's time zone, working days and holidays are set once, in the business calendar.",
    },
    provider: {
      vllm: "vLLM (our servers)",
      ollama: "Ollama (our servers)",
      openai_compatible: "OpenAI-compatible server",
      openai: "OpenAI",
      anthropic: "Anthropic",
      azure: "Microsoft Azure OpenAI",
      bedrock: "Amazon Bedrock",
      google: "Google",
      mistral: "Mistral AI",
      deepseek: "DeepSeek",
      cohere: "Cohere",
      groq: "Groq",
    },
    filters: {
      period: "When",
      person: "Person",
      agent: "Agent",
      case: "Case",
      byId: "Search by id (for experts)",
      ids: { run_id: "Run id", case_id: "Case id", actor_user: "Person id", actor_agent: "Agent id" },
    },
    subjects: {
      find: "Find the person",
      findHelp: "Search by name or e-mail.",
      byId: "I have the person's user id (for example a former employee)",
      exportCsv: "Download as a spreadsheet (CSV)",
      csv: { memory: "Remembered", consent: "Consent", record: "Record", kind: "Kind" },
    },
    identities: {
      auto: "Agents get their identity automatically",
      autoHow: "It is created and confirmed when a version is first released to any stage; every Live release confirms it again. You only need the manual actions to repair an identity.",
      manualTitle: "Repair an identity by hand (administrators)",
      manualHelp: "Use this only when the automatic set-up failed or for an agent outside the registry.",
      manualToggle: "Show manual register and confirm actions",
      agent: "Agent",
      waiting: "Waiting for its first release",
      confirmed: "Confirmed",
      confirmedFor: "Confirmed for version {{version}} ({{envs}})",
      advanced: "Technical values (advanced)",
    },
    env: { dev: "development", test: "testing", staging: "final check", prod: "Live" },
    preset: {
      title: "What does this person do?",
      help: "Pick one or more jobs; the matching roles are ticked below. You can still adjust single roles.",
      canDo: "This person can:",
      nothing: "No access yet: pick a job above.",
      exact: "Exact roles",
      case_worker: { name: "Case worker", can: "Works cases: opens them, adds notes, parties and documents." },
      case_supervisor: { name: "Case supervisor", can: "Everything a case worker does, plus reassigns work and reopens cases." },
      approver: { name: "Approver", can: "Reviews and decides approval requests in the inbox." },
      finance_approver: { name: "Finance approver", can: "Decides payment and finance approvals." },
      agent_builder: { name: "Builder", can: "Creates and tests agents, manages knowledge and test sets." },
      release_approver: { name: "Release approver", can: "Approves moving agents to Testing and Live." },
      contact_centre_agent: { name: "Support desk", can: "Answers customers handed over by agents on Channels › Desk." },
      contact_centre_supervisor: { name: "Support desk supervisor", can: "Watches and steers the support desk." },
      privacy_officer: { name: "Privacy officer", can: "Answers personal-data requests: access, export and erasure." },
      auditor: { name: "Auditor", can: "Reads the audit log and cases; changes nothing." },
      manager: { name: "Manager", can: "Sees outcomes and return on investment." },
      knowledge_curator: { name: "Knowledge curator", can: "Adds, updates and removes documents in knowledge collections." },
      team_admin: { name: "Organisation admin", can: "Manages people, organisation settings, case types, agent identities, channels and guardrails." },
      platform_admin: { name: "Platform admin", can: "Runs the platform for every organisation: systems and tools, AI models, Marketplace and platform settings." },
      platform_auditor: { name: "Platform auditor", can: "Checks the audit trail of any organisation; changes nothing." },
      single: "+{{count}} single roles",
      advanced: "Advanced: single roles",
      advancedHelp: "Only when a job above doesn't fit. Each role is one permission.",
    },
  },
  ar: {
    loading: "جارٍ التحميل…",
    person: {
      placeholder: "ابحث بالاسم أو البريد الإلكتروني",
      failed: "تعذّر تحميل الأشخاص. حاول بعد قليل.",
      none: "لم يُعثر على أحد. تحقق من الإملاء أو جرّب البريد الإلكتروني.",
      noneInQueue: "لا يوجد أحد في هذه القائمة يطابق البحث.",
      fromQueue: "يُعرض فقط من يعملون في هذه القائمة.",
    },
    queue: { ...queueAr, placeholder: "اختر قائمة عمل", help: "الفريق الذي يعالج الحالات الجديدة من هذا النوع." },
    caseType: {
      placeholder: "اختر نوع الحالة",
      other: "أخرى ({{key}})",
      help: "يحدد نوع الحالة من يعالجها ومدة الرد والمعلومات المطلوبة.",
    },
    agent: { placeholder: "اختر وكيلًا", failed: "تعذّر تحميل الوكلاء.", none: "لا يوجد وكلاء بعد." },
    case: { placeholder: "ابحث في الحالات بالعنوان أو المرجع", failed: "تعذّر تحميل الحالات.", none: "لم يُعثر على حالة.", selected: "الحالة المختارة" },
    timezone: { placeholder: "ابحث عن مدينة أو منطقة زمنية" },
    schemaForm: {
      empty: "(فارغ)",
      yes: "نعم",
      no: "لا",
      rawLabel: "كل القيم كرمز (JSON)",
      rawInvalid: "هذا ليس JSON صالحًا بعد. يُطبَّق التغيير عندما يصبح صالحًا.",
      rawToggle: "العرض كرمز (للمختصين)",
      rawHelp: "عدّل القيم بصيغة JSON بدلًا من النموذج.",
      noSchema: "لا يصف هذا الإجراء حقوله، لذا تُعرض قيمه كرمز.",
      extra: "غير موصوف في الإجراء؛ يُرسل كما هو.",
      noChanges: "لا توجد تغييرات.",
      becomes: "يصبح",
      issue: {
        required: "مطلوب.",
        type: "أدخل قيمة من النوع الصحيح ({{type}}).",
        enum: "اختر إحدى القيم المعروضة.",
        min: "يجب ألا يقل عن {{n}}.",
        max: "يجب ألا يزيد على {{n}}.",
        minLength: "يجب ألا يقل عن {{n}} حرفًا.",
        maxLength: "يجب ألا يزيد على {{n}} حرفًا.",
        pattern: "الصيغة غير مقبولة.",
        notAllowed: "لا يقبل هذا الإجراء هذا الحقل.",
      },
    },
    error: {
      raw: "رسالة النظام: {{raw}}",
      kind: {
        offline: { title: "تعذّر الوصول إلى المنصة", next: "تحقق من الاتصال وحاول مرة أخرى. إن تكرر ذلك فأبلغ المسؤول." },
        signed_out: { title: "انتهت جلستك", next: "سجّل الدخول مرة أخرى وكرر الإجراء." },
        forbidden: { title: "لا تملك صلاحية تنفيذ هذا", next: "اطلب الصلاحية من المسؤول إن كنت تحتاجها." },
        not_found: { title: "هذا العنصر لم يعد موجودًا", next: "أعد تحميل الصفحة؛ ربما حذفه أحد أو نقله." },
        conflict: { title: "غيّر أحدهم هذا في الوقت نفسه", next: "أعد التحميل لترى أحدث نسخة ثم حاول مرة أخرى." },
        invalid: { title: "بعض المعلومات تحتاج إلى تصحيح", next: "صحّح المعلومات المحددة وحاول مرة أخرى." },
        too_large: { title: "الملف كبير جدًا", next: "اختر ملفًا أصغر أو قسّمه." },
        unsupported: { title: "نوع الملف غير مدعوم", next: "استخدم ملف PDF أو صورة أو مستندًا مكتبيًا." },
        rate_limited: { title: "طلبات كثيرة في الوقت الحالي", next: "انتظر دقيقة ثم حاول مرة أخرى." },
        unavailable: { title: "جزء من المنصة غير متاح حاليًا", next: "لم يتغير شيء. حاول مرة أخرى بعد دقائق." },
        server: { title: "حدث خطأ في المنصة", next: "لم يتغير شيء. حاول مرة أخرى، وإن تكرر ذلك فأبلغ المسؤول." },
        unknown: { title: "لم يكتمل الإجراء", next: "حاول مرة أخرى، وإن تكرر ذلك فأبلغ المسؤول." },
      },
      detail: {
        not_found_thing: "تعذّر العثور عليه ({{thing}}).",
        changed_meanwhile: "غيّره شخص آخر أثناء عملك. أعد التحميل لترى التغيير.",
        claimed_by_other: "يعمل مراجع آخر على هذه المهمة بالفعل.",
        task_state: "هذه المهمة في حالة {{status}} بالفعل، فلا يمكن تغييرها الآن.",
        status_transition: "لا يمكن نقل الحالة من {{from}} إلى {{to}}.",
        user_exists: "يوجد شخص بهذا الاسم أو البريد الإلكتروني بالفعل.",
        already_deployed: "هذا الإصدار مستخدم هناك بالفعل.",
        promote_first: "انقله إلى {{env}} أولًا.",
        case_type_in_use: "توجد حالات من هذا النوع، فلا يمكن حذفه. أوقفه بدلًا من ذلك.",
        needs_role: "ليس لحسابك صلاحية الوصول إلى هذا. إن كنت تحتاجها فاطلبها من المسؤول.",
        not_participant: "لست ممن يعملون على هذه الحالة.",
        not_in_queue: "لست عضوًا في قائمة العمل التي تتبع لها هذه المهمة.",
        assignee_or_supervisor: "لا يمكن تنفيذ هذا إلا للمكلّف بها أو لمشرف الحالات.",
        reopen_supervisor: "لا يعيد فتح حالة مغلقة إلا مشرف الحالات.",
        clearance: "مستوى تصريحك أقل من تصنيف هذه الحالة.",
        human_only: "يجب أن ينفذ هذا شخص مسجّل الدخول مباشرة، لا عبر وكيل.",
        other_tenant: "هذا يخص جهة أخرى.",
        missing_field: "معلومة ناقصة: {{field}}.",
        must_be_number: "يجب أن يكون {{field}} رقمًا.",
        must_be_date: "يجب أن يكون {{field}} تاريخًا.",
        case_type_off: "هذا النوع من الحالات موقوف. اختر نوعًا آخر.",
        unknown_timezone: "{{zone}} ليست منطقة زمنية معروفة.",
        hours_order: "يجب أن يبدأ يوم العمل قبل أن ينتهي.",
        no_working_days: "اختر يوم عمل واحدًا على الأقل.",
        edits_required: "غيّر قيمة واحدة على الأقل، أو اختر «اعتماد».",
        signature_required: "تعذّر توقيع الاعتماد. حاول مرة أخرى.",
        input_no_reject: "لا يمكن رفض طلب معلومات. أعد إسناده أو صعّده.",
        assignee_or_queue: "اختر شخصًا أو قائمة عمل.",
        one_file: "اختر ملفًا واحدًا.",
        invalid_generic: "هذه القيمة غير مقبولة.",
        roles_not_assignable: "لا يمكن منح هذه الأدوار: {{roles}}.",
        email_invalid: "عنوان البريد الإلكتروني غير صالح.",
        username_invalid: "يتكون اسم المستخدم من حروف إنجليزية صغيرة وأرقام ونقاط وشرطات (من 3 إلى 63 حرفًا).",
        idp_rejected: "رفض نظام تسجيل الدخول التغيير (مثل كلمة مرور ضعيفة).",
        field_required: "هذا الحقل مطلوب.",
        too_long: "النص طويل جدًا (الحد {{n}} حرفًا).",
        too_short: "النص قصير جدًا (على الأقل {{n}} حرفًا).",
        wrong_format: "الصيغة غير مقبولة.",
        must_be_number_generic: "أدخل رقمًا.",
        too_small: "يجب ألا يقل عن {{n}}.",
        too_big: "يجب ألا يزيد على {{n}}.",
        value_error: "{{text}}",
        audit_down: "سجل التدقيق غير متاح، لذا لم يتغير شيء. حاول بعد دقائق.",
        idp_down: "نظام تسجيل الدخول غير متاح. حاول بعد دقائق.",
        service_down: "إحدى خدمات المنصة غير متاحة. حاول بعد دقائق.",
      },
    },
    edit: {
      title: "تعديل القيم",
      help: "صحّح ما اقترحه الوكيل. يُوقَّع التعديل مع قرارك ويكمل الوكيل بقيمك.",
      valid: "جميع القيم صالحة.",
      fix: "صحّح الحقول المحددة أولًا ({{count}}).",
      changes: "ما الذي غيّرته",
      diffChanged: "القيم التي ستُستخدم، مع تمييز تعديلاتك.",
      diffSame: "القيم التي اقترحها الوكيل.",
    },
    reassign: { pick: "اختر شخصًا من هذه القائمة", done: "أُعيد إسناد المهمة" },
    tech: {
      toolAction: "إجراء الأداة",
      argsJson: "القيم كرمز",
      step: "الخطوة",
      documentUri: "عنوان المستند",
      mediaType: "نوع الملف",
      outcomeCode: "رمز النتيجة",
    },
    chat: {
      canDo: "ما الذي يستطيع فعله:",
      aboutAgent: "عن {{name}}",
      tryAsking: "جرّب أن تسأل",
    },
    documents: {
      unnamed: "مستند",
      kind: { pdf: "مستند PDF", png: "صورة", jpeg: "صورة", tiff: "صورة ممسوحة", plain: "ملف نصي", other: "مستند" },
      added: "أُضيف {{when}}",
      read: "قرأته خدمة ذكاء المستندات",
      readFailed: "تعذّرت قراءة المستند.",
      attached: "أُرفق {{name}}: {{kind}}، {{pages}} صفحة.",
      attachedPending: "أُرفق {{name}}. ما زالت قراءته جارية، وستظهر التفاصيل لاحقًا.",
      failed: "لم يُرفق {{name}}.",
      classification: "درجة الحساسية",
      reading: "جارٍ قراءة {{name}}…",
      upload: "رفع مستند",
      help: "يُقرأ المستند (نوعه وعدد صفحاته والبيانات الشخصية فيه) ثم يُرفق بهذه الحالة.",
    },
    identifier: {
      title: "المعرّفات",
      none: "لا توجد معرّفات بعد.",
      type: "نوع المعرّف",
      value: "الرقم أو القيمة",
      add: "إضافة معرّف",
      remove: "إزالة {{type}}",
      types: {
        national_id: "الهوية الوطنية / الإقامة",
        cr_number: "رقم السجل التجاري",
        iban: "رقم الآيبان",
        passport: "رقم جواز السفر",
        email: "البريد الإلكتروني",
        phone: "الهاتف",
        employee_no: "الرقم الوظيفي",
        vendor_no: "رقم المورّد",
      },
      hint: {
        generic: "تحقق من هذه القيمة.",
        national_id: "عادةً 10 أرقام تبدأ بـ 1 (مواطن) أو 2 (مقيم).",
        cr_number: "عادةً 10 أرقام.",
        iban: "مثال: SA03 8000 0000 6080 1016 7519.",
        passport: "حروف وأرقام فقط.",
        email: "مثال: name@example.com.",
        phone: "أرقام فقط، مثال: ‎+966 5X XXX XXXX.",
      },
    },
    tenant: {
      regionHelp: "مكان حفظ بيانات الجهة. الخيارات مأخوذة من النماذج المسجلة.",
      regionsHelp: "لا تُنتج إجابات النماذج إلا في هذه المناطق. اتركها فارغة للسماح بأي منطقة معتمدة.",
      anyRegion: "أي منطقة معتمدة",
      providersHelp: "مزوّدو النماذج المسموح للجهة باستخدامهم. اتركها فارغة للسماح بكل مزوّد معتمد.",
      anyProvider: "كل مزوّد معتمد",
      timezoneLink: "التغيير من تقويم العمل",
      timezoneHelp: "تُضبط المنطقة الزمنية للجهة وأيام العمل والعطل مرة واحدة في تقويم العمل.",
    },
    provider: {
      vllm: "vLLM (خوادمنا)",
      ollama: "Ollama (خوادمنا)",
      openai_compatible: "خادم متوافق مع OpenAI",
      openai: "OpenAI",
      anthropic: "Anthropic",
      azure: "Microsoft Azure OpenAI",
      bedrock: "Amazon Bedrock",
      google: "Google",
      mistral: "Mistral AI",
      deepseek: "DeepSeek",
      cohere: "Cohere",
      groq: "Groq",
    },
    filters: {
      period: "متى",
      person: "الشخص",
      agent: "الوكيل",
      case: "الحالة",
      byId: "البحث بالمعرّف (للمختصين)",
      ids: { run_id: "معرّف التشغيل", case_id: "معرّف الحالة", actor_user: "معرّف الشخص", actor_agent: "معرّف الوكيل" },
    },
    subjects: {
      find: "ابحث عن الشخص",
      findHelp: "ابحث بالاسم أو البريد الإلكتروني.",
      byId: "لدي معرّف المستخدم (مثل موظف سابق)",
      exportCsv: "تنزيل كجدول (CSV)",
      csv: { memory: "محفوظ في الذاكرة", consent: "موافقة", record: "السجل", kind: "النوع" },
    },
    identities: {
      auto: "يحصل الوكلاء على هويتهم تلقائيًا",
      autoHow: "تُنشأ الهوية وتُؤكَّد عند أول إصدار للوكيل في أي مرحلة، ويُعاد تأكيدها مع كل إصدار في التشغيل الفعلي. لا تحتاج إلى الإجراءات اليدوية إلا لإصلاح هوية.",
      manualTitle: "إصلاح هوية يدويًا (للمسؤولين)",
      manualHelp: "استخدم هذا فقط إذا فشل الإعداد التلقائي أو لوكيل خارج السجل.",
      manualToggle: "إظهار إجراءات التسجيل والتأكيد اليدوية",
      agent: "الوكيل",
      waiting: "بانتظار أول إصدار",
      confirmed: "مؤكَّدة",
      confirmedFor: "مؤكَّدة للإصدار {{version}} ({{envs}})",
      advanced: "قيم تقنية (متقدم)",
    },
    env: { dev: "التطوير", test: "الاختبار", staging: "الفحص النهائي", prod: "التشغيل الفعلي" },
    preset: {
      title: "ماذا يعمل هذا الشخص؟",
      help: "اختر وظيفة أو أكثر؛ ستُحدد الأدوار المناسبة في الأسفل. يمكنك تعديل الأدوار منفردة.",
      canDo: "يستطيع هذا الشخص:",
      nothing: "لا صلاحيات بعد: اختر وظيفة في الأعلى.",
      exact: "الأدوار بالتفصيل",
      case_worker: { name: "موظف حالات", can: "يعالج الحالات: يفتحها ويضيف الملاحظات والأطراف والمستندات." },
      case_supervisor: { name: "مشرف حالات", can: "كل ما يفعله موظف الحالات، ويعيد إسناد العمل ويعيد فتح الحالات." },
      approver: { name: "معتمد", can: "يراجع طلبات الاعتماد في صندوق المهام ويقرر فيها." },
      finance_approver: { name: "معتمد مالي", can: "يقرر في اعتمادات الدفع والشؤون المالية." },
      agent_builder: { name: "باني الوكلاء", can: "ينشئ الوكلاء ويختبرهم ويدير المعرفة ومجموعات الاختبار." },
      release_approver: { name: "معتمد إصدارات", can: "يعتمد نقل الوكلاء إلى الاختبار والتشغيل الفعلي." },
      contact_centre_agent: { name: "مكتب الدعم", can: "يجيب العملاء المحوَّلين من الوكلاء في مكتب الموظفين ضمن القنوات." },
      contact_centre_supervisor: { name: "مشرف مكتب الدعم", can: "يتابع مكتب الدعم ويوجهه." },
      privacy_officer: { name: "مسؤول خصوصية", can: "يجيب طلبات البيانات الشخصية: الاطلاع والتصدير والمحو." },
      auditor: { name: "مدقق", can: "يقرأ سجل التدقيق والحالات دون أن يغيّر شيئًا." },
      manager: { name: "مدير", can: "يطّلع على النتائج والعائد على الاستثمار." },
      knowledge_curator: { name: "أمين المعرفة", can: "يضيف المستندات في مجموعات المعرفة ويحدّثها ويزيلها." },
      team_admin: { name: "مسؤول الجهة", can: "يدير الأشخاص وإعدادات الجهة وأنواع الحالات وهويات الوكلاء والقنوات والضوابط." },
      platform_admin: { name: "مسؤول المنصة", can: "يدير المنصة لكل الجهات: الأنظمة والأدوات ونماذج الذكاء الاصطناعي والسوق وإعدادات المنصة." },
      platform_auditor: { name: "مدقق المنصة", can: "يفحص سجل التدقيق لأي جهة؛ لا يغيّر شيئًا." },
      single: "+{{count}} أدوار منفردة",
      advanced: "متقدم: الأدوار المنفردة",
      advancedHelp: "فقط عندما لا تناسب أي وظيفة في الأعلى. كل دور صلاحية واحدة.",
    },
  },
};
